import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    alias: '/home',
    meta: {
      title: '深圳和安国际货运代理有限公司'
    }
  },
  {
    path: '/trackResult',
    name: 'trackResult',
    component: () => import(/* webpackChunkName: "about" */ '@/views/TrackResult.vue'),
    alias: '/trackResult',
    meta: {
      title: '深圳和安国际货运代理有限公司'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})

export default router
